module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Rose_HK.9465a856.png";